<template>
    <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent>
        <q-card class="desgloce-dialog"
            style="width:1100px; max-width: 100vw; height: 90vh; display: flex; flex-direction: column;">
            <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
                <q-icon name="mdi-arrow-decision-outline" size="28px" class="q-mr-sm" />
                <q-toolbar-title>
                    <div class="text-h6">Desgloce</div>
                    <div class="text-caption text-white-7">Pegue el contenido copiado desde Excel</div>
                </q-toolbar-title>
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Cerrar (ESC)</q-tooltip>
                </q-btn>
            </q-toolbar>

            <div class="row no-wrap content-scrollable">
                <!-- Columna principal: paste box + tabla -->
                <div class="col-12 col-md-8 q-pa-md scroll-area">
                    <div class="paste-box">
                        <q-input borderless type="textarea" v-model="pasteText"
                            placeholder="Pegue aquí el contenido del archivo..." rows="4" class="paste-input"
                            @paste="onPaste" @update:model-value="parsePasteText">
                            <template v-slot:prepend>
                                <q-icon name="content_paste" size="24px" color="grey-6" />
                            </template>
                        </q-input>
                    </div>

                    <div class="row justify-end q-mt-sm">
                        <q-btn unelevated color="primary" icon="calculate" label="Calcular Desgloce"
                            :loading="calculando" :disable="filas.length === 0 || calculando" @click="calcularDesgloce">
                            <template v-slot:loading>
                                <q-spinner-hourglass size="20px" />
                            </template>
                        </q-btn>
                    </div>

                    <q-separator class="q-my-md" />

                    <template v-if="filas.length > 0">
                        <div class="table-scroll">
                            <q-markup-table flat wrap-cells dense class="modern-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">Producto</th>
                                        <th class="text-right">Cantidad</th>
                                        <th class="text-right">Largo</th>
                                        <th class="text-right">Precio</th>
                                        <th class="text-right">Total</th>
                                        <th class="text-right">Prorrateo</th>
                                        <th class="text-center" width="60">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(fila, index) in filas" :key="index" class="table-row-hover">
                                        <td class="text-left">{{ fila.producto?.B1_COD || fila.producto }}</td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(fila.cantidad, true) }}
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            <span v-if="fila.largo !== null">{{ numberFormat(fila.largo, true) }}</span>
                                            <span v-else class="text-grey-5">—</span>
                                        </td>
                                        <td class="text-right">
                                            <span v-if="fila.precio !== null">{{ numberFormat(fila.precio) }}</span>
                                            <span v-else class="text-grey-5">—</span>
                                        </td>
                                        <td class="text-right text-weight-bold">
                                            <span v-if="fila.total !== null">{{ numberFormat(fila.total) }}</span>
                                            <span v-else class="text-grey-5">—</span>
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            <span v-if="fila.prorrateo !== null">{{ numberFormat(fila.prorrateo)
                                                }}</span>
                                            <span v-else class="text-grey-5">—</span>
                                        </td>
                                        <td class="text-center">
                                            <q-btn flat dense round icon="delete" size="sm" color="negative"
                                                @click="filas.splice(index, 1)">
                                                <q-tooltip>Eliminar fila</q-tooltip>
                                            </q-btn>
                                        </td>
                                    </tr>
                                    <tr v-if="calculated" class="totals-row">
                                        <td colspan="4" class="text-right text-weight-bold">TOTALES:</td>
                                        <td class="text-right text-weight-bold">{{ numberFormat(totalReal) }}</td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(totalProrrateado) }}
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </q-markup-table>
                        </div>
                    </template>
                    <div v-else class="text-center text-grey-6 q-pa-lg">
                        Pegue el contenido para ver la vista previa
                    </div>
                </div>

                <!-- Columna lateral: Resumen -->
                <div class="col-12 col-md-4 bg-grey-1 q-pa-md gt-sm scroll-area">
                    <div class="sticky-summary">
                        <q-card flat bordered class="summary-card">
                            <q-card-section class="bg-primary text-white">
                                <div class="text-h6">
                                    <q-icon name="calculate" size="24px" class="q-mr-sm" />
                                    Resumen del Desgloce
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section>
                                <div class="summary-row">
                                    <span class="text-grey-8">
                                        <q-icon name="account_balance_wallet" size="18px" class="q-mr-xs" />
                                        Total Presupuesto
                                    </span>
                                    <span class="text-h6 text-primary text-weight-bold">
                                        {{ numberFormat(totalCamaraDisplay) }}
                                    </span>
                                </div>

                                <q-separator class="q-my-md" />

                                <div class="summary-row">
                                    <span class="text-grey-8">Total Real</span>
                                    <span class="text-weight-medium">{{ numberFormat(totalReal) }}</span>
                                </div>

                                <q-separator class="q-my-md" />

                                <div class="summary-row">
                                    <span class="text-grey-8">
                                        <q-icon name="compare_arrows" size="18px" class="q-mr-xs" />
                                        Diferencia
                                    </span>
                                    <span class="text-weight-bold"
                                        :class="diferencia >= 0 ? 'text-positive' : 'text-negative'">
                                        {{ numberFormat(diferencia) }}
                                    </span>
                                </div>

                                <div class="summary-row">
                                    <span class="text-grey-8">% Diferencia</span>
                                    <span class="text-weight-medium"
                                        :class="diferencia >= 0 ? 'text-positive' : 'text-negative'">
                                        {{ porcentajeDiferencia }}%
                                    </span>
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section class="q-pa-sm">
                                <q-linear-progress :value="Math.min(Math.abs(porcentajeDiferencia) / 100, 1)"
                                    :color="diferencia >= 0 ? 'positive' : 'negative'" size="8px" rounded />
                                <div class="text-caption text-center text-grey-7 q-mt-xs">
                                    {{ diferencia >= 0 ? 'Superávit' : 'Déficit' }}
                                </div>
                            </q-card-section>
                            <q-separator />
                            <q-card-section class="q-pa-sm">
                                <q-banner rounded  class="bg-red-2 text-grey-8">
                                    <q-icon name="info" size="18px" class="q-mr-sm" />
                                    Con la confirmacion del desgloce, los cambios serán guardados permanentemente y
                                    el presupuesto sera movido a estado <q-badge color="green"> CONFIRMADO </q-badge>. Esta acción no se puede deshacer.
                                </q-banner>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </div>

            <q-separator />
            <q-card-actions class="q-pa-md bg-white actions-fixed">
                <div class="row full-width q-gutter-sm">
                    <div class="col">
                        <q-btn outline label="Cerrar" color="grey-7" icon="close" v-close-popup class="full-width" />
                    </div>
                    <div class="col">
                        <q-btn :disabled="filas.length === 0" outline label="Confirmar" color="primary" icon="check" @click="guardaDesgloce" class="full-width" />
                    </div>
                </div>
            </q-card-actions>

            <q-inner-loading :showing="calculando">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import numberFormat from "@/helpers/numberFormat";
import IngenieriaService from "@/services/IngenieriaService";

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    camara: {
        type: Object,
        required: true,
    },
    presupuestoId: {
        type: Number,
        required: true,
    },
});
const emits = defineEmits(["update:modelValue", "desgloce-confirmado"]);

const pasteText = ref("");
const filas = ref([]);
const calculando = ref(false);
const calculated = ref(false);
const totalCamara = ref(null);

const parsePasteText = () => {
    const lineas = pasteText.value.split("\n").filter((linea) => linea.trim() !== "");

    calculated.value = false;
    filas.value = lineas
        .map((linea) => {
            const tokens = linea.trim().split(/\s+/).filter(Boolean);
            if (tokens.length < 2) {
                return null;
            }

            const producto = tokens[0];
            const cantidad = parseFloat(tokens[1].replace(",", "."));
            const largo = tokens.length >= 3 ? parseFloat(tokens[2].replace(",", ".")) : null;

            if (!producto || Number.isNaN(cantidad) || (largo !== null && Number.isNaN(largo))) {
                return null;
            }

            return { producto, cantidad, largo, precio: null, total: null, prorrateo: null };
        })
        .filter((fila) => fila !== null);
};

const onPaste = (event) => {
    const texto = event.clipboardData?.getData("text");
    if (texto === undefined) {
        return;
    }
    event.preventDefault();
    pasteText.value = texto;
    parsePasteText();
};

const totalCamaraDisplay = computed(
    () => totalCamara.value ?? props.camara?.total ?? 0
);
const totalReal = computed(() => filas.value.reduce((acc, fila) => acc + (fila.total ?? 0), 0));
const totalProrrateado = computed(() => filas.value.reduce((acc, fila) => acc + (fila.prorrateo ?? 0), 0));
const diferencia = computed(() => totalCamaraDisplay.value - totalReal.value);
const porcentajeDiferencia = computed(() => {
    if (!totalCamaraDisplay.value) {
        return 0;
    }
    return ((diferencia.value / totalCamaraDisplay.value) * 100).toFixed(2);
});

const calcularDesgloce = async () => {
    calculando.value = true;
    try {
        const response = await IngenieriaService.desglocePresupuesto({
            camara: {
                id: props.camara.id,
                total: props.camara.total,
            },
            filas: filas.value.map((fila) => ({
                producto: fila.producto,
                cantidad: fila.cantidad,
                largo: fila.largo,
            })),
        });
        totalCamara.value = response.total_camara;
        filas.value = filas.value.map((fila, index) => ({
            ...fila,
            ...response.datos[index],
            prorrateo: response.datos[index]?.total_ponderado ?? null,
        }));
        calculated.value = true;
    } catch (error) {
        // el interceptor global ya muestra el detalle del error al usuario
    } finally {
        calculando.value = false;
    }
};

watch(
    () => props.modelValue,
    (isOpen) => {
        if (!isOpen) {
            pasteText.value = "";
            filas.value = [];
            calculated.value = false;
            calculando.value = false;
            totalCamara.value = null;
        }
    }
);

const guardaDesgloce = async () => {
    console.log("items", filas.value);
    calculando.value = true;
    try {
        const response = await IngenieriaService.agregaProductosDesglozados({
            presupuestoId: props.presupuestoId,
            camaraId: props.camara.id,
            items: filas.value,
        });
        calculated.value = true;
        emits("desgloce-confirmado");
    } catch (error) {
        // el interceptor global ya muestra el detalle del error al usuario
    } finally {
        calculando.value = false;
    }
};
</script>

<style lang="scss" scoped>
.desgloce-dialog {
    border-radius: 16px;
    overflow: hidden;

    .bg-gradient-primary {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    }

    .toolbar-fixed {
        flex-shrink: 0;
    }

    .content-scrollable {
        flex: 1;
        overflow: hidden;
    }

    .scroll-area {
        overflow-y: auto;
        max-height: 100%;
        min-width: 0;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    .table-scroll {
        overflow-x: auto;

        &::-webkit-scrollbar {
            height: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    .actions-fixed {
        flex-shrink: 0;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }
}

.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

.paste-box {
    display: flex;
    align-items: flex-start;
    padding: 12px;
    border: 2px dashed #bdbdbd;
    border-radius: 8px;
    background: #fafafa;
}

.paste-input {
    flex: 1;
}

// Sticky summary en desktop
.sticky-summary {
    position: sticky;
    top: 0;
}

.summary-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 16px;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    span:first-child {
        flex: 1;
    }

    span:last-child {
        text-align: right;
        word-break: break-word;
    }
}

.modern-table {
    border-radius: 8px;
    overflow: hidden;

    :deep(thead) {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

        tr th {
            color: white;
            font-weight: 600;
            padding: 12px;
            text-transform: uppercase;
            font-size: 0.75rem;
        }
    }

    :deep(tbody) {
        tr {
            transition: background-color 0.2s ease;

            &.table-row-hover:hover {
                background-color: rgba(25, 118, 210, 0.04);
            }

            &.totals-row {
                background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                font-size: 1rem;

                td {
                    padding: 12px;
                    border-top: 2px solid #1976d2;
                }
            }
        }
    }
}

// Responsive
@media (max-width: 1023px) {
    .desgloce-dialog {
        border-radius: 0;
    }

    .sticky-summary {
        position: relative;
        top: 0;
    }
}
</style>
